import { render, staticRenderFns } from "./DashboardDisplay.vue?vue&type=template&id=4913c9f6&"
import script from "./DashboardDisplay.vue?vue&type=script&lang=js&"
export * from "./DashboardDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports